import { render, staticRenderFns } from "./StrategyList.vue?vue&type=template&id=8a2d7150&"
import script from "./StrategyList.vue?vue&type=script&lang=ts&"
export * from "./StrategyList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports